import client from '../../../../axios-client';

export default {
  loadCancellationReviews: (context, payload) => {
    if (context.getters.generic) {
      return;
    }
    client
      .getCancellationReviews(
        context.getters.cancellationId,
        payload.limit,
        payload.offset,
      ).then((response) => {
        if ('success' === response.data.status) {
          context.commit('setCancellationReviewsLoading', false);
          context.commit('setCancellationReviews', response.data.data);
          context.commit('setTotalCancellationReviews', response.headers['x-total-count']);
        }
      });
  },
};
